export const BASE_URL = process.env.NODE_ENV == "development" ? "/apis/" : "https://www.318btt.com/";
// export const BASE_URL = process.env.NODE_ENV == "development" ? "/apis/" : "https://release.888b.com/";
export const ENDPOINT_URL = process.env.NODE_ENV == "development" ? "/api" : "https://test.shopeelive.co";

export const REQUEST_API = {
  userRegister: "member/member/register",
  userLogin: "member/member/login",
  userConfig: "member/member/configure/1",
  createCustomer: "https://8b.waebox.com/api/v3/customer/createCustomerInfo",
  endpointReg: "/register",
  endpointLogin: "/login",
  getCodeImg: "member/system/getCaptchaImage",
  getGa: "member/background/agentUrl/list"
};



// WEBPACK FOOTER //
// ./src/utils/api.js